import { render, staticRenderFns } from "./AddOfferItems.vue?vue&type=template&id=f007cc0a&scoped=true"
import script from "./AddOfferItems.vue?vue&type=script&lang=ts"
export * from "./AddOfferItems.vue?vue&type=script&lang=ts"
import style0 from "./AddOfferItems.vue?vue&type=style&index=0&id=f007cc0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f007cc0a",
  null
  
)

export default component.exports